export default __webpack_public_path__ + "static/media/nr3.8a7ca10f.svg";